export const MOB_MAX_WIDTH = "600px";
